import { UserRole } from '@mairistem/finances-utils';
import TypePeriode from '../../constants/simulation/typePeriode';
import type TreeRow from '../../interfaces/feuilleSaisie/treeRow';

export interface ServiceRestriction {
	identifiantSvutCpta: number;
	identifiantsServicesUtilisateur: number[];
}

// Permet de savoir si on desactive les champs par manque d'habilitation
const isInputDisabled = (
	transfertCpta: boolean,
	typePeriode: TypePeriode,
	userRole: UserRole,
	gestionnaireCanWhenDemande = false,
	serviceRestriction?: ServiceRestriction,
	blockNonProprietaire = false,
) => {
	// Si on est transfere en compta, plus de modification de montant
	if (transfertCpta) return true;

	// Si la gestion de service est active, un Gestionnaire/Normal ne peut agir que sur
	// les montants dont il est l'auteur et dont le service fait partie de ses propres
	// services. Un Charge de pilotage/Admin n'est pas soumis a ces restrictions.
	if (userRole < UserRole.CHARGE_PILOTAGE) {
		if (blockNonProprietaire) return true;

		if (
			serviceRestriction &&
			!serviceRestriction.identifiantsServicesUtilisateur.includes(
				serviceRestriction.identifiantSvutCpta,
			)
		) {
			return true;
		}
	}

	switch (typePeriode) {
		case TypePeriode.DEMANDE:
			// Admin/ChargePilotage/(Gestionnaire si autorise)
			return (
				userRole <
				(gestionnaireCanWhenDemande
					? UserRole.GESTIONNAIRE
					: UserRole.CHARGE_PILOTAGE)
			);
		case TypePeriode.CA_CFU:
		case TypePeriode.PROPOSE:
		case TypePeriode.VOTE:
			// Admin/ChargePilotage
			return userRole < UserRole.CHARGE_PILOTAGE;
		default:
			return true;
	}
};

// Indique si la saisie directe dans le TreeView est bloquee pour la ligne
// (hors habilitation, cf isInputDisabled) :
// - en gestion par service, toujours (seule MontantsSimulationModal permet de
// choisir un service),
// - sur une ligne APCP, toujours,
// - avec plusieurs montants, toujours (on ne saurait pas lequel modifier),
// - en gestion des demandes, des que la ligne porte un montant avec origine
// (idee importee, calcul...) : la saisie ne reste possible qu'avec aucun
// montant (creation d'une ligne sans origine) ou un seul montant sans origine
// (modifie). Sans nombre_montant_sans_origine, la saisie reste bloquee
export const isSaisieTreeViewBloquee = (
	rowData: TreeRow,
	saisieBudgetService: boolean,
	isDemandeEnabled: boolean,
) =>
	saisieBudgetService ||
	rowData.has_idsi_pro_imputations ||
	rowData.nombre_montant > 1 ||
	(isDemandeEnabled &&
		rowData.nombre_montant_sans_origine !== rowData.nombre_montant);

export default isInputDisabled;
